module.exports = __webpack_public_path__ + "img/purple.1f9da8aa.png";